export default function cityListByStateQuery(stateId) {
  const query = `{cityListByState(stateId: ${stateId}){id, ibgeId, name, uf, stateId}}`;
  return query;
}
